import { z } from 'zod';
// Invoice goes out through Bexio, the other two are collected by Stripe.
export const subscriptionPaymentMethodSchema = z.enum(['Card', 'Twint', 'Invoice']);
export const SubscriptionPaymentMethod = subscriptionPaymentMethodSchema.enum;
